import {
  Bold, Italic, Strikethrough,
  Heading1, Heading2, Heading3,
  List, ListOrdered, CheckSquare, Code, Quote,
  Image as ImageIcon, Table as TableIcon, Minus,
  Undo2, Redo2, Highlighter, RemoveFormatting, ExternalLink, Paperclip,
} from 'lucide-react';

export default function EditorToolbar({ editor, onInsertImage, onInsertTable, onShowEmbed, onAttach }) {
  return (
    <div className="flex items-center gap-0.5 px-2 sm:px-4 py-1.5 border-b border-border/30 overflow-x-auto no-scrollbar bg-secondary/20" data-testid="editor-toolbar">
      <Btn icon={Undo2} onClick={() => editor?.chain().focus().undo().run()} disabled={!editor?.can().undo()} title="Undo" testId="editor-undo" />
      <Btn icon={Redo2} onClick={() => editor?.chain().focus().redo().run()} disabled={!editor?.can().redo()} title="Redo" testId="editor-redo" />
      <Divider />
      <Btn icon={Bold} onClick={() => editor?.chain().focus().toggleBold().run()} active={editor?.isActive('bold')} title="Bold (Ctrl+B)" testId="editor-bold" />
      <Btn icon={Italic} onClick={() => editor?.chain().focus().toggleItalic().run()} active={editor?.isActive('italic')} title="Italic (Ctrl+I)" testId="editor-italic" />
      <Btn icon={Strikethrough} onClick={() => editor?.chain().focus().toggleStrike().run()} active={editor?.isActive('strike')} title="Strikethrough" testId="editor-strike" />
      <Btn icon={Highlighter} onClick={() => editor?.chain().focus().toggleHighlight().run()} active={editor?.isActive('highlight')} title="Highlight" testId="editor-highlight" />
      <Divider />
      <Btn icon={Heading1} onClick={() => editor?.chain().focus().toggleHeading({ level: 1 }).run()} active={editor?.isActive('heading', { level: 1 })} title="Heading 1" testId="editor-h1" />
      <Btn icon={Heading2} onClick={() => editor?.chain().focus().toggleHeading({ level: 2 }).run()} active={editor?.isActive('heading', { level: 2 })} title="Heading 2" testId="editor-h2" />
      <Btn icon={Heading3} onClick={() => editor?.chain().focus().toggleHeading({ level: 3 }).run()} active={editor?.isActive('heading', { level: 3 })} title="Heading 3" testId="editor-h3" />
      <Divider />
      <Btn icon={List} onClick={() => editor?.chain().focus().toggleBulletList().run()} active={editor?.isActive('bulletList')} title="Bullet List" testId="editor-ul" />
      <Btn icon={ListOrdered} onClick={() => editor?.chain().focus().toggleOrderedList().run()} active={editor?.isActive('orderedList')} title="Numbered List" testId="editor-ol" />
      <Btn icon={CheckSquare} onClick={() => editor?.chain().focus().toggleTaskList().run()} active={editor?.isActive('taskList')} title="Task List" testId="editor-task" />
      <Divider />
      <Btn icon={Code} onClick={() => editor?.chain().focus().toggleCodeBlock().run()} active={editor?.isActive('codeBlock')} title="Code Block" testId="editor-code" />
      <Btn icon={Quote} onClick={() => editor?.chain().focus().toggleBlockquote().run()} active={editor?.isActive('blockquote')} title="Quote" testId="editor-quote" />
      <Divider />
      <Btn icon={ImageIcon} onClick={onInsertImage} title="Insert Image" testId="editor-image" />
      <Btn icon={TableIcon} onClick={onInsertTable} title="Insert Table" testId="editor-table" />
      <Btn icon={ExternalLink} onClick={onShowEmbed} title="Insert Embed (YouTube, Twitter, Spotify)" testId="editor-embed" />
      <Btn icon={Paperclip} onClick={onAttach} title="Attach File" testId="editor-attach" />
      <Btn icon={Minus} onClick={() => editor?.chain().focus().setHorizontalRule().run()} title="Horizontal Rule" testId="editor-hr" />
      <Divider />
      <Btn icon={RemoveFormatting} onClick={() => editor?.chain().focus().clearNodes().unsetAllMarks().run()} title="Clear Formatting" testId="editor-clear-format" />
    </div>
  );
}

function Btn({ icon: Icon, onClick, active, disabled, title, testId }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      data-testid={testId}
      className={`flex-shrink-0 p-2 rounded-sm transition-colors ${
        active
          ? 'bg-muted text-foreground'
          : disabled
          ? 'text-muted-foreground/30 cursor-not-allowed'
          : 'text-muted-foreground hover:text-foreground hover:bg-muted/50 active:bg-muted'
      }`}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}

function Divider() {
  return <div className="w-px h-4 bg-border mx-0.5 flex-shrink-0" />;
}
